function addBusinessDays(startDate, n) {
  const d = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) added++;
  }
  return d;
}

function formatDDMM(date) {
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  return `${dd}.${mm}`;
}

const getDeliveryString = (raw) => {
  let [minStr, maxStr] = raw.includes('-') ? raw.split('-').map((s) => s.trim()) : [raw, raw];
  const min = parseInt(minStr, 10),
    max = parseInt(maxStr, 10);
  if (isNaN(min) || isNaN(max)) return;

  const today = new Date();
  const earliest = addBusinessDays(today, min);
  const latest = addBusinessDays(today, max);

  return {
    string: min === max ? `${formatDDMM(earliest)}` : `${formatDDMM(earliest)} - ${formatDDMM(latest)}`,
    max,
  };
};

function calculateCartDeliveryDateFromItems() {
  const itemNodes = document.querySelectorAll('.cart-item--data-delivery[data-delivery-time]');
  if (!itemNodes.length) return null;

  const dates = [];

  itemNodes.forEach((node) => {
    const raw = node.getAttribute('data-delivery-time');
    if (!raw) return;
    dates.push(getDeliveryString(raw));
  });

  let currentMax = dates[0].max;
  let currentString = dates[0].string;

  if (dates.length > 1) {
    dates.forEach((item) => {
      if (item.max > currentMax) {
        currentMax = item.max;
        currentString = item.string;
      }
    });
  }

  return currentString ?? null;
}

async function syncCartDeliveryAttribute() {
  const el = document.getElementById('cart-current-delivery-date');
  const savedValue = (el && (el.getAttribute('data-value') || '').trim()) || '';
  const newValue = calculateCartDeliveryDateFromItems();

  console.log('newValue', newValue);

  if (!newValue) {
    console.debug('[delivery_date] Brak wyliczonej wartości – nic nie robię.');
    return;
  }

  if (newValue === savedValue) {
    console.debug('[delivery_date] Wartość bez zmian – skip update.');
    return;
  }

  try {
    const response = await fetch(
      (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            delivery_date: newValue,
          },
        }),
      }
    );

    if (!response.ok) {
      console.error('[delivery_date] Błąd przy /cart/update.js:', response.status, response.statusText);
      return;
    }

    const cart = await response.json();
    console.debug('[delivery_date] Zaktualizowano cart.attributes.delivery_date', cart.attributes);

    if (el) {
      el.textContent = newValue;
    }
  } catch (error) {
    console.error('[delivery_date] Exception przy update atrybutu:', error);
  }
}

['DOMContentLoaded', 'cart:refresh'].forEach((eventName) => {
  document.addEventListener(eventName, syncCartDeliveryAttribute);
});
